import { render, staticRenderFns } from "./_SearchByQuestionModal.vue?vue&type=template&id=0d641436&scoped=true&"
import script from "./_SearchByQuestionModal.vue?vue&type=script&lang=js&"
export * from "./_SearchByQuestionModal.vue?vue&type=script&lang=js&"
import style0 from "./_SearchByQuestionModal.vue?vue&type=style&index=0&id=0d641436&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d641436",
  null
  
)

export default component.exports